(function($) {
  function moveToolTip() {
    $('.tooltip-container').append($('.wiper-info-wrap').closest('.shopify-section'));
  }
  
  

var revokeDiscoutTierBar = (cart) => {
  
  console.log('rebuy:cart.enriched event>>', cart); 
  var threshold_1 = 15000,
      threshold_2 = 30000,
      threshold_3 = 45000,
      require_mgs_1 = "\u003cp\u003eSpend XX more to unlock 14% off.\u003c\/p\u003e",
      require_mgs_2 = "\u003cp\u003eSpend XX more to unlock 18% off.\u003c\/p\u003e",
      require_mgs_3 = "\u003cp\u003eSpend XX more to unlock 26% off.\u003c\/p\u003e",
      success_mgs_1 = "\u003cp\u003e🎉 Congrats! You've unlocked\u003cstrong\u003e \u003c\/strong\u003eour\u003cstrong\u003e 14% off discount tier.\u003c\/strong\u003e\u003c\/p\u003e",
      success_mgs_2 = "\u003cp\u003e🎉 Congrats! You've unlocked\u003cstrong\u003e \u003c\/strong\u003eour\u003cstrong\u003e 18% off discount tier.\u003c\/strong\u003e\u003c\/p\u003e",
      success_mgs_3 = "\u003cp\u003e🎉 Congrats! You've unlocked\u003cstrong\u003e \u003c\/strong\u003eour\u003cstrong\u003e 26% off discount tier.\u003c\/strong\u003e\u003c\/p\u003e",
      dtb_enable = false;
  console.log(dtb_enable)
  var threshold = threshold_1,require_mgs = require_mgs_1, success_mgs = '', cart_total_price = cart.total_price;
  
  if(cart_total_price >= threshold_1 && cart_total_price < threshold_2 && cart_total_price < threshold_3) {
    threshold = threshold_2;
    require_mgs = require_mgs_2;
    success_mgs = success_mgs_1;
  } else if(cart_total_price >= threshold_1 && cart_total_price >= threshold_2 && cart_total_price < threshold_3) {
    threshold = threshold_3;
    require_mgs = require_mgs_3;
    success_mgs = success_mgs_2;
  } else if(cart_total_price >= threshold_1 && cart_total_price >= threshold_2 && cart_total_price >= threshold_3) {
    threshold = '';
    require_mgs = '';
    success_mgs = success_mgs_3;
  }
  
  if(dtb_enable && cart.item_count) {
    var r_cls = (threshold == '')?'hide':'',
        remain_require = threshold - cart_total_price,
        bar_width = 100 - (remain_require / cart_total_price) * 100;
    var discoutBarHTML = `<div id="discoutBarHTML" class="rebuy-cart__flyout-shipping-bar has-discount-bar">
      <div class="rebuy-cart__flyout-shipping-bar-message">
      <div class="success_mgs">${success_mgs}</div>
      <div class="require_mgs ${r_cls}">${require_mgs?.replace('XX', theme.Currency.formatMoney(remain_require, theme.settings.moneyFormat))}</div>
      </div>
      <div class="rebuy-cart__flyout-shipping-bar-meter has-progress">
        <div class="rebuy-cart__flyout-shipping-bar-meter-fill" style="width: ${(bar_width > 100)?100:bar_width}%;">
        <span class="rebuy-cart__flyout-shipping-bar-meter-fill-text">100%</span>
      </div> 
    </div>`;

    $('#discoutBarHTML').remove();
    $('.rebuy-cart__flyout-content').before(discoutBarHTML);
  } else {
    $('#discoutBarHTML').remove();
  }
}
})(jQuery);